module.exports = __webpack_public_path__ + "static/media/CASA MANFREDI-14.9c7808f5.svg";